import { Stack, Typography } from "@mui/material"
import { FC } from "react"

import { create } from "src/helpers/bem"

import { useTranslation } from "src/hooks/translation"

import { useAccount } from "src/states/account"
import { useLocale } from "src/states/locale"

import styles from "./AccountProfile.module.scss"

const bem = create(styles, "AccountProfile")

export const CompanyData: FC = () => {
  const { messages: translations } = useTranslation()
  const account = useAccount()
  const locale = useLocale()
  const profileTranslations = translations.pages.account.overview.profile

  const data = [
    {
      label: profileTranslations.company.name,
      value: account.company1 ?? "",
    },
    {
      label: profileTranslations.company.street,
      value: account.companyStreet ?? "",
    },
    {
      label: profileTranslations.company.zip,
      value: account.companyZipCode ?? "",
    },
    {
      label: profileTranslations.company.city,
      value: account.companyCity ?? "",
    },
    {
      label: profileTranslations.company.country,
      value:
        locale === "de"
          ? (account.companyCountryCode?.germanName ?? "")
          : (account.companyCountryCode?.englishName ?? ""),
    },
    {
      label: profileTranslations.company.email,
      value: account.companyEmail ?? "--",
    },
    // {
    //   label: profileTranslations.company.phone,
    //   value: "Phone missing in interface",
    // },
    // {
    //   label: profileTranslations.company.tax,
    //   value: "Tax missing in interface",
    // },
  ]

  return (
    <Stack className={bem("card")} direction={"column"}>
      <Stack
        className={bem("card", "header")}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <Typography variant="subtitle1">
          {profileTranslations.headers.company}
        </Typography>
        {/* <Stack direction={"row"} spacing={0.75}>
          <Typography className={bem("varified")} variant="body2">{profileTranslations.headers.varified}</Typography>
          <VerifiedIcon className={bem("varified", "icon")} />
        </Stack> */}
      </Stack>
      <Stack className={bem("card", "content")} direction={"column"}>
        {data.map((item) => (
          <Stack
            key={item.label}
            className={bem("data")}
            direction={"row"}
            justifyContent={"flex-start"}
          >
            <Typography variant={"body1"}>{item.label}:</Typography>
            <Typography variant={"body1"}>{item.value}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  )
}
